import { Navigate, useOutletContext } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { FIRM_ROLE, FirmStatusContent } from '../components/firm/FirmApproval';
import { KvkkRenewalBanner } from '../components/firm/KvkkRenewalBanner';

export default function FirmStatusPage() {
  const { user } = useAuth();
  const { myCompany, reloadMyCompany, firmPermitCount } = useOutletContext();
  if (user?.role !== FIRM_ROLE) return <Navigate to="/" replace />;
  return (
    <div className="max-w-2xl space-y-5" data-testid="firm-status-page" data-allow-pending>
      <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Firma Onay Durumu</h1>
      <KvkkRenewalBanner company={myCompany} onChanged={reloadMyCompany} />
      {myCompany ? <FirmStatusContent company={myCompany} onChanged={reloadMyCompany} permitCount={firmPermitCount} /> : <Loader2 className="h-6 w-6 animate-spin text-slate-400" />}
    </div>
  );
}
